import isEmpty from "lodash/isEmpty";

import TippyTooltip from "@stadium/ui/src/components/tooltip/tooltip";
import Multimedia from "@sharedComponents/multimedia";

import { OPTIONTYPE_SIZE_KEY } from "@constants/products/detail";

import { InternalButton } from "@sharedComponents/buttons";

import styles from "./main.module.scss";

const emptyArr = [];

const SwagViewOnlyVariantDetails = ({
  colorVariantData = emptyArr,
  allSizesVariants = emptyArr,
  handleChange,
  isPurchasable,
}) => {
  const isColorOutOfStock = (data) => {
    if (!isEmpty(data.variants)) {
      const isAllSizesOutOfStock = data.variants.every(({ outOfStock }) => outOfStock);
      if (isAllSizesOutOfStock) return true;
    }
    return data.outOfStock;
  };

  const renderColorVariant = (data) => {
    if (isColorOutOfStock(data)) return;
    const isOptionTypeSize = OPTIONTYPE_SIZE_KEY.includes(data.optionTypeKey);
    return (
      <TippyTooltip
        content={(data.colorOutOfStock && "Out of Stock") || data.presentation}
        isLightTheme={true}
        placement="top-start"
        arrow={true}
        customClassName={styles.colorVariantTippy}
        childrenWrapperClassName={styles.thumbBox}
      >
        {isOptionTypeSize ? (
          <InternalButton
            key={data.id}
            className={styles.roundOption}
            onClick={() => handleChange(data)}
            styleType="no-style"
            disabled={!isPurchasable}
          >
            <span className={`${styles.roundOptionSpan} ${styles["rdWidth"]}`}>
              {data.presentation}
            </span>
          </InternalButton>
        ) : (
          <Multimedia
            type="image"
            src={data.image}
            alt={data.presentation}
            height={66}
            width={66}
            onClick={() => {
              if (!isPurchasable) return;
              handleChange(data);
            }}
            key={data.id}
            className={styles.thumbImg}
            unoptimized
          />
        )}
      </TippyTooltip>
    );
  };
  const renderSizeVariant = ({ outOfStock, presentation }) => {
    if (outOfStock) return;
    return (
      <span className={styles.sizeOptionRead} key={presentation}>
        {presentation}
      </span>
    );
  };
  return (
    <>
      {!isEmpty(colorVariantData) && (
        <div className={`${styles.mb16} ${styles.rdSelector}`}>
          <div className={`${styles.title} ${styles.primaryColor} `}>Available Colors</div>
          <div className={`${styles.dFlexRd} ${styles.readOnlyText} ${styles.readOnly}`}>
            {colorVariantData.map(renderColorVariant)}
          </div>
        </div>
      )}
      {!isEmpty(allSizesVariants) && (
        <div className={styles.sizeOptionWrap}>
          <div className={styles.readOnly}>
            <div className={styles.title}>Available Sizes</div>
            <div className={styles.sizeVariantReadOnly}>
              {allSizesVariants.map(renderSizeVariant)}
            </div>
            <div className={styles.sizeNote}>Recipients choose size/color during redemption.</div>
          </div>
        </div>
      )}
    </>
  );
};
export default SwagViewOnlyVariantDetails;
